import { isSome } from 'utility-belt/typeguards';
export const LocalStorage = {
  get: getStorageStrategyValue(localStorage),
  set: setStorageStrategyValue(localStorage),
  clear: clearStorageStrategyValue(localStorage)
};
export const SessionStorage = {
  get: getStorageStrategyValue(sessionStorage),
  set: setStorageStrategyValue(sessionStorage),
  clear: clearStorageStrategyValue(sessionStorage)
};
function getStorageStrategyValue(strategy) {
  return function getStoredValue(key) {
    try {
      const entry = strategy.getItem(key);
      if (!isSome(entry) || entry === '') {
        return null;
      }
      return JSON.parse(entry);
    } catch (_unused) {
      return null;
    }
  };
}
function setStorageStrategyValue(strategy) {
  return function setStoredValue(key, value) {
    try {
      strategy.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    } catch (_unused2) {
      return;
    }
  };
}
function clearStorageStrategyValue(strategy) {
  return function clearStoredValue(key) {
    try {
      strategy.removeItem(key);
    } catch (_unused3) {
      return;
    }
  };
}